import { Avatar, AvatarProps } from "antd";
import dummyImage from "assets/img/anonymous_user.svg";

const VLAvatar = ({
  src,
  size = "large",
  shape = "circle",
  ...rest
}: AvatarProps) => (
  <Avatar
    {...rest}
    src={src || dummyImage}
    size={size}
    shape={shape}
    icon={dummyImage}
  />
);

export default VLAvatar;
